export { default as Footer } from './component';


// WEBPACK FOOTER //
// ./src/components/mainLayout/footer/index.js